import config from 'src/config';
import ContactPanel from 'components/ContactPanel';
import HelpPanel from 'components/HelpPanel';
console.log('config', config);
console.log('config', config.layout);
console.log('config', config.layout.components);
var HomePanel = config.layout.components.HomePanel();
import { GiscubeLayout } from '@giscube/geoportal';
var routes = [{
  path: '/',
  component: GiscubeLayout,
  children: [{
    path: 'contact/',
    component: ContactPanel,
    name: 'contact'
  }, {
    path: 'help/',
    component: HelpPanel,
    name: 'help'
  }, {
    path: 'home/',
    component: HomePanel,
    name: 'home'
  }, {
    path: '',
    redirect: {
      name: 'home'
    }
  }]
}];
export default routes;